import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url} from '@/utils/baseUrl';

//币种
export async function getbzlist(params) {
    return post(erpserver+'/currency/getbzlist', params, true);
}
//国家
export async function getDqList(params) {
    return post(oaserver+'/oacurrency/getDqList', params, true);
}
//总行
export async function getParentBankList(params) {
    return post(oaserver+'/dict/bank/getParentBankList', params, true);
}
//支行
export async function getSubBankList(params) {
    return post(oaserver+'/dict/bank/getSubBankList', params, true);
}
//新增公司
export async function addCompany(params) {
    return post(oaserver+'/organize/addCompany', params, true);
}
//银行列表
export async function getBankDictList(params) {
    return post(oaserver+'/dict/bank/getBankDictList', params, true);
}
//银行新增
export async function addBankDict(params) {
    return post(oaserver+'/dict/bank/addBankDict', params, true);
}
//银行新增
export async function editBankDict(params) {
    return post(oaserver+'/dict/bank/editBankDict', params, true);
}
